/* eslint-env es2020 */

/**
 * Use custom, debounced events :
 *    window.OP.addEventListener('resize', (currentWidth) => {});
 *    window.OP.resizeCallbacks.push( (currentWidth) => {} );
 *    window.OP.addEventListener('scroll', (currentScrollTop) => {});
 *    window.OP.scrollCallbacks.push( (currentScrollTop) => {} );
 * will be fired on scroll and resize events, and a first time when page loaded
 *
 * Use custom waitFor dependencies :
 *    window.OP.waitFor('jQuery.fn.popover', () => {...})
 *    window.OP.waitFor(['jQuery.fn.popover', 'jQuery.fn.tooltip'], () => {...})
 *    window.OP.waitFor('jQuery.fn.popover', () => {...}, { keepTrying: true, numTries: 15, onFail: () => {...} })
 */
 window.OP = {
  addEventListener: (type, callback) => {
    window.OP[`${type}Callbacks`].push(callback);
  },
  resizeCallbacks: [],
  scrollCallbacks: [],
  debounce: (func, wait, immediate) => {
    let timeout;
    return function debounced(...args) {
      const context = this;
      const later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  waitFor: (names, cb, options) => {
    options = options || {};
    let numWaitTries = options.hasOwnProperty('numTries') ? options.numTries : 20;
    if (options.hasOwnProperty('keepTrying') && options.keepTrying) numWaitTries = -1;
    const waitForNames = Array.isArray(names) ? names : [names];
    const waitForProp = () => {
      if (!waitForNames.filter((name) => window.OP.deepFind(window, name) === undefined).length) {
        cb();
      } else {
        numWaitTries -= 1;
        if (numWaitTries !== 0) {
          setTimeout(waitForProp, 50);
        } else if (options.hasOwnProperty('onFail')) {
          options.onFail();
        }
      }
    };
    waitForProp();
  },
  deepFind: (obj, path) => {
    const paths = path.split('.');
    let current = obj;
    let i;
    for (i = 0; i < paths.length; ++i) {
      if (current[paths[i]] === undefined) {
        return undefined;
      }
      current = current[paths[i]];
    }
    return current;
  },
};
(() => {
  let windowWidth = window.innerWidth;
  let windowScrollTop = window.pageYOffset;

  const executeCallbacks = (name, param) => window.OP[name].forEach((callback) => callback(param));

  setTimeout(() => {
    // Resize callbacks
    let resizeTimeout;
    window.addEventListener('resize', () => {
      windowWidth = window.innerWidth;
      if (resizeTimeout) window.cancelAnimationFrame(resizeTimeout);
      resizeTimeout = window.requestAnimationFrame(() => executeCallbacks('resizeCallbacks', windowWidth));
    });
    executeCallbacks('resizeCallbacks', windowWidth);

    // Scroll callbacks
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      windowScrollTop = window.pageYOffset;
      if (scrollTimeout) window.cancelAnimationFrame(scrollTimeout);
      scrollTimeout = window.requestAnimationFrame(() => executeCallbacks('scrollCallbacks', windowScrollTop));
    });
    executeCallbacks('scrollCallbacks', windowScrollTop);
  }, 1);
})();
